import { Component, createSignal } from "solid-js";
import DefaultModal from "../elements/DefaultModal";
import HeaderModal from "../elements/HeaderModal";
import ChooseEmail from "../elements/ChooseEmail";
import AddExternalEmail from "../elements/AddExternalEmail";

import Styles from "bundle-text:../styles/_senderMailModal.scss";

interface SenderMailModalProps {
  show: boolean;
  onClose: () => void;
  onNext: () => void;
}

const SenderMailModal: Component<SenderMailModalProps> = (props) => {
  const [email, setEmail] = createSignal("");

  const handleSelect = (email: string) => {
    setEmail(email);
  };

  const handleExternalEmail = (email: string) => {
    setEmail(email);
    console.log("External email:", email);
  };

  return (
    <>
      <style>{Styles}</style>
      <DefaultModal show={props.show} topBar={40}>
        <HeaderModal title="Sender Mail" onClose={props.onClose} />
        <div class="sender-mail-modal-content">
          <p class="title">Connected domain: builderall.com.br</p>
          <p>
            By creating a custom email on the domain that you connected, you can
            send emails to your subscribers that look professional and match the
            website that is on that domain. Your emails will show as coming from
            the custom email you have created.
          </p>

          <div className="gap">
            <ChooseEmail
              emails={["email1.com", "email2.com", "email3.com"]}
              onSelect={handleSelect}
            />

            <AddExternalEmail onInput={handleExternalEmail} />
          </div>

          <footer>
            <a href="#">
              <builderall-icon code="help"></builderall-icon>I don't have a
              custom email yet.
            </a>
            <button onClick={props.onNext}>next</button>
          </footer>
        </div>
      </DefaultModal>
    </>
  );
};

export default SenderMailModal;
